module.exports = __webpack_public_path__ + "media/images/favicons/favicon-52eb867e749cad185ff385d030d75ccb.ico";